/**
 * Hashes a string to a hexadecimal string using SHA-256.
 * Taken and modified from https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#supported_algorithms
 * @param str The input string to hash.
 * @returns A promise that resolves to the hexadecimal string representation of the hash.
 */
export async function toHashHexStringAsync(str: string): Promise<string> {
  const strUint8 = new TextEncoder().encode(str); // encode as (utf-8) Uint8Array
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', strUint8); // hash the string

  // If the new API is supported, use it.
  if ((Uint8Array.prototype as any).toHex) {
    // Use toHex if supported.
    return (new Uint8Array(hashBuffer) as any).toHex(); // Convert ArrayBuffer to hex string.
  }

  // If toHex() is not supported, fall back to an alternative implementation.
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray
    .map(b => b.toString(16).padStart(2, '0'))
    .join(''); // convert bytes to hex string

  return hashHex;
}
